import { getExperiment } from '@pegasus/abtesting';
import { TEST_VARIANT1, TEST_ID as orangeTestId } from '@shared/abtests/accessibleOrange';

export const getHasAccessibleOrange = state => {
    const experiment = getExperiment(state, orangeTestId);

    return experiment && experiment.variant === TEST_VARIANT1;
};
